/**
 * A freshly verified login session may bridge the login route and AppShell.
 * The short freshness window prevents a duplicate blocking request while the
 * normal 30-second server revalidation remains authoritative.
 */
export const appSessionQueryPolicy = Object.freeze({
    bootstrapFreshnessMs: 5_000,
    refreshIntervalMs: 30_000,
});
//# sourceMappingURL=app-session-query-policy.js.map